module.exports = {
	siteName: 'players',
	appI18nConfig: {
		defaultLocale: 'en',
		supportedLocales: ['en', 'ko', 'fr', 'ar', 'pt', 'es', 'id', 'th'],
	},
};